import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'pages.list.search-placeholder': {
    id: 'pages.list.search-placeholder',
    defaultMessage: 'Search Cookbook',
  },
  'pages.list.header': {
    id: 'pages.list.header',
    defaultMessage: 'Cloudinary Cookbook',
  },
  'pages.list.search.no-results.title': {
    id: 'pages.list.search.no-results.title',
    defaultMessage: 'No recipes match your search',
  },
  'pages.list.search.no-results.subtitle': {
    id: 'pages.list.search.no-results.subtitle',
    defaultMessage: 'Refine your search or go to <action>Cloudinary Cookbook</action> page',
  },
  'pages.list.view-recipe': {
    id: 'pages.list.view-recipe',
    defaultMessage: 'Read more',
  },

  'pages.details.buttons.back': {
    id: 'pages.details.buttons.back',
    defaultMessage: 'Back to Cookbook',
    description: 'label of navigation button displayed on details page',
  },
  'pages.details.not-found-text': {
    id: 'pages.details.not-found-text',
    defaultMessage: 'The recipe not found',
  },
});
